import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import consola from 'consola';
import categoryQuery from '~/graphql/category.gql';
import { extractCategoryHash, buildCategoryProductsQuery } from '~/helpers/extract-helper';

function fetchCategory(_x, _x2, _x3) {
  return _fetchCategory.apply(this, arguments);
}

function _fetchCategory() {
  _fetchCategory = _asyncToGenerator(function* (context, alias, query) {
    let profileId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    const hash = extractCategoryHash(alias);
    const locale = context.state.i18n.currentLocale.iso;
    const {
      offset,
      limit,
      sortBy,
      orderBy,
      filterBy
    } = buildCategoryProductsQuery(query);
    const withBrand = process.client && context.$cookies.get('product-brand') === 1;

    try {
      const response = yield context.app.apolloProvider.defaultClient.query({
        query: categoryQuery,
        variables: {
          profileId,
          variantImageTransformation: process.client && context.$cookies.get('smart-crop-variants') ? 'g_auto,c_crop,r_max' : '',
          locale,
          hash,
          offset,
          limit,
          sortBy,
          orderBy,
          filterBy,
          withBrand
        }
      });
      return response.data;
    } catch (e) {
      consola.error(e);
      return null;
    }
  });
  return _fetchCategory.apply(this, arguments);
}

export { fetchCategory as default };